<template>
  <center>
    <div class="card card-body agatrs-card-style">
      <Header pageTitle="Manage Transactions" class="card-container"></Header>
      <!-- <div v-if="duringSubmit" class="loading">
        <Loading/>
      </div> -->
      <edit-modal
        v-bind:id="editId"
        v-on:modal-close="modalClose"
        ref="transactionEditModal"
      >
      </edit-modal>
      <div class="col-md-12">
        <div class="row">
          <export-group :name="'Transactions'" v-bind:isLoading="duringSubmit" v-on:loading="toggleLoading" :excelUrl="`api/ordertransactions/excel`" :getData="getExportData"></export-group>

          <div class="col-md-4 offset-md-8">
            <div class="row flex-row-reverse">
              <div class="col-md-8">
            <label for="searchBox">Search:</label>
            <el-input
              id="searchBox"
              type="search"
              class="mb-3 search-input"
              clearable
              prefix-icon="el-icon-search"
              @input="search()"
              v-model="searchText"
              placeholder="Search all Transactions..."
            ></el-input>
          </div>

            <div v-if="isPM1Account" class="col-md-4">
                <label for="searchBox">Show More</label>
                <div>
                  <el-switch v-model="showMoreToggle" v-on:change="toggleShowMoreFunction" active-color="#275d34"
                    inactive-color="grey">
                  </el-switch>
                </div>
              </div>
          </div>
          </div>
        
        </div>
      </div>

      <div class="col-md-12">
        <el-table
          :data="paginatedTransactions.results"
          :default-sort="{ prop: 'orderStatusName', order: 'ascending' }"
        >
          <el-table-column :min-width="185" align="left" label="Actions">
            <div slot-scope="props">
              <router-link
                v-if="!isCompletedOrCancelled(props.row.orderStatusName)"
                :to="'/admin/transactions/view/' + props.row.orderId"
                class="btn-link btn-primary"
                :aria-label="`View Order No ${props.row.orderId}`"
              >
                <i class="tim-icons icon-zoom-split"></i>
                <span class="hide-if-small-screensize">View</span>
              </router-link>
                <span  class="hide-if-medium-screensize"></span>
                <router-link
                v-if="isCompletedOrCancelled(props.row.orderStatusName)"
                  :to="'/admin/transactions/' + props.row.orderId"
                  class="btn-link btn-primary"
                  :aria-label="`Edit Order No ${props.row.orderId}`"
                >
                  <i class="tim-icons icon-pencil"></i>
                  <span class="hide-if-small-screensize">Edit</span>
                </router-link>
                <!-- TODO !!!!!!!!!!!!!!!!!!!Below is the modal method for edit transaction, I leave the code here in case we go back to
                 this way. The connected component is EditModal.vue-->
                <!-- <a
                  href="#"
                  @click.stop.prevent="clickShowDetailsModal(props.row.orderId)"
                  class="btn-link btn-danger"
                >
                  <i class="tim-icons icon-trash-simple"></i>
                  <span class="hide-if-small-screensize">Edit2</span>
                </a> -->
                <span  class="hide-if-medium-screensize"></span>
                   <a
                v-if="!isCompletedOrCancelled(props.row.orderStatusName)"
                href="##"
                @click.stop.prevent="openRevertModal(props.row.orderId)"
                :aria-label="`Revert Order No ${props.row.orderId}`"
                class="btn-link btn-danger"
              >
                <i class="tim-icons icon-refresh-01"></i>
                <span class="hide-if-small-screensize">Revert</span>
              </a>
                <a
                v-if="isCompletedOrCancelled(props.row.orderStatusName)"
                  href="##"
                  @click.stop.prevent="handleCancel(props.row.orderId)"
                  class="btn-link btn-danger"
                  :aria-label="`Cancel Order No ${props.row.orderId}`"
                >
                  <i class="tim-icons icon-trash-simple"></i>
                  <span class="hide-if-small-screensize">Cancel</span>
                </a>              
            </div>
          </el-table-column>
          <el-table-column
            v-for="column in tableColumns"
            sortable
            :key="column.label"
            :min-width="column.minWidth"
            :prop="column.prop"
            :label="column.label"
          ></el-table-column>
          
          <!-- have to move these people columns out in order to put the icon in -->
          <el-table-column
            sortable
            prop="assignedLogisticsUser"
            label="Logistics"
            minWidth="150"
          >
            <template slot-scope="order">
              <i
                v-if="order.row.logisticsUser && Number(order.row.logisticsUser.approvalStatusId) === lockedStatusId && !isPartnerAccount"
                class="tim-icons icon-lock-circle"
              ></i>
              <span style="background: none;"> {{ order.row.logisticsUserName }}</span>
            </template>
          </el-table-column>

          <el-table-column
            sortable
            prop="assignedFinanceUser"
            label="Finance"
            minWidth="150"
          >
            <template slot-scope="order">
              <i
                v-if="order.row.financeUser && Number(order.row.financeUser.approvalStatusId) === lockedStatusId && !isPartnerAccount"
                class="tim-icons icon-lock-circle"
              ></i>
              <span style="background: none;"> {{ order.row.financeUserName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            prop="assignedPartnerUser"
            label="Partner Nation"
            minWidth="160"
          >
            <template slot-scope="order">
              <i
                v-if="order.row.partnerNationUser && Number(order.row.partnerNationUser.approvalStatusId) === lockedStatusId"
                class="tim-icons icon-lock-circle"
              ></i>
              <span style="background: none;"> {{ order.row.partnerNationName }}</span>
            </template>
          </el-table-column>
        </el-table>
        

        <div class="row justify-content-end">
          <label for="ResultsPerPageDropdown" class="results-per-page"
            >Results Per Page:</label
          >
          <el-select
            id="ResultsPerPageDropdown"
            v-model="pageCount"
            @change="getPaginateTransactions()"
            name="PageOptions"
            class="select-primary"
          >
            <el-option
              v-for="(item, index) in pageCountOptions"
              :value="item"
              class="select-primary"
              :key="index"
            ></el-option>
          </el-select>

          <base-pagination
            v-model="paginatedTransactions.currentPage"
            @input="getPaginateTransactions()"
            :perPage="paginatedTransactions.pageSize"
            :pageCount="paginatedTransactions.pageCount"
          >
          </base-pagination>
        </div>
      </div>
      <b-modal
        ref="revertModal"
        scrollable
        hide-footer
        hide-header
        no-close-on-backdrop
        size="lg"
        body-class="custom_alert_body"
      >
        <div class="alert_header align-center">
          <br />
          Revert Order ID#{{ this.selectedOrderToRevert }} (Revert to the
          Submitted Status)
        </div>
        <div class="container">
          <div class="col-md-12">
            Please provide a brief justification for reverting the order back to
            its previous status:
          </div>
          <div class="col-md-12">
            <textarea
              class="fullWidth"
              v-model="reasonForRevertingOrder"
              placeholder=""
            ></textarea>
          </div>
        </div>

        <div class="alert_footer align-left">
          <div class="col-md-5 align-left">
            <base-button
              type="primary"
              @click="closeRevertModal()"
              class="btn-primary"
            >
              <i class="tim-icons icon-double-left"></i> Return to Admin
              Transactions
            </base-button>
          </div>
          <!-- <div class="col-md-2"></div> -->
          <div class="col-md-3 align-left">
            <base-button type="danger" @click="revertOrderToSubmittedStatus()">
              <i class="tim-icons icon-alert-circle-exc"></i> Revert
            </base-button>
          </div>
        </div>
      </b-modal>
    </div>
  </center>
</template>

<script>
import Util from "@/util/util";
import { mapGetters, mapActions } from "vuex";
import { Table, TableColumn, Select, Option , Switch} from "element-ui";
import Treeselect from "@riophae/vue-treeselect";
import { BaseButton, Modal, BasePagination, BaseSwitch , ExportGroup } from "@/components";
import swal from "sweetalert2";
import Header from "@/components/App/Header.vue";
import Loading from 'src/components/LoadingPanel';
import EditModal from '@/components/admin/EditModal';

import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "admin-transactions-dashboard",
  components: {
    EditModal,
    [Table.name]: Table,
    [Switch.name]: Switch,
    [TableColumn.name]: TableColumn,
    BaseSwitch,
    BaseButton,
    BasePagination,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    Treeselect,
    Header,
    ExportGroup,
    Loading,
    EditModal
  },
  data() {
    return {
      editId: undefined,
      showTransactionModal: false,
      showMoreToggle: false,
      map: {
        "OrderId": "orderId",
        "RequisitionNumber": "requisitionNumber",
        "FinanceOrganization": "financeOrganizationName",
        "FinanceUser": "financeUserName",
        "LogisticsOrganization": "logisticsOrganizationName",
        "LogisticsUser": "logisticsUserName",
        "OrderStatus": "orderStatusName",
      },
      duringSubmit: false,
      tableColumns: [
        {
          prop: "orderId",
          label: "Order Number",
          minWidth: 160,
        },
        {
          prop: "requisitionNumber",
          label: "Requisition Number",
          minWidth: 200,
        },
        {
          prop: "organizationName",
          label: "Organization Name",
          minWidth: 200,
        },
        {
          prop: "serviceName",
          label: "Service Name",
          minWidth: 170,
        },
        // {
        //   prop: "logisticsUserName",
        //   label: "Logistic User",
        //   minWidth: 180,
        // },
        {
          prop: "logisticsOrganizationName",
          label: "Logistic Organization",
          minWidth: 210,
        },
        // {
        //   prop: "financeUserName",
        //   label: "Finance User",
        //   minWidth: 180,
        // },
        {
          prop: "financeOrganizationName",
          label: "Finance Organization",
          minWidth: 210,
        },
        
        {
          prop: "orderStatusName",
          label: "Order Status",
          minWidth: 150,
        },
      ],
      searchTimeOut: null,
      selectedOrderToRevert: 0,
      reasonForRevertingOrder: "",
      pageCount: 5,
      searchText: "",
      pageCountOptions: [],
      lockedStatusId: 0
    };
  },
  mounted() {
    this.pageCountOptions = Util.getInitialPaginationInfo().perPage;
    this.pageCountOptions = Util.getInitialPaginationInfo().perPageOptions;

    this.getPaginateTransactions();
    this.lockedStatusId = Util.LOCKED;
  },
  watch:{
    showMoreToggle: function(value){
    this.getPaginateTransactions();
    }
  },
  computed: {
    ...mapGetters({
      transactions: "transactions/allTransactions",
      paginatedTransactions: "transactions/paginatedTransactions",
      transaction: "transactions/transaction",
      allTransactionsForExporting: "transactions/allTransactionsForExporting",
      isPM1Account: "authentication/isPM1Account",
      isSuperAdmin: "authentication/isSuperAdmin",
      isPartnerAccount: "authentication/isPartnerAccount",


    }),
    allTableData() {
      return this.allTransactionsForExporting;
    },
  },
  methods: {
    ...mapActions({
      getTransactions: "transactions/getTransactions",
      getServiceTransactions: "transactions/getServiceTransactions",
      getPaginatedTransactions: "transactions/getPaginatedTransactions",
      getPaginatedServiceTransactions: "transactions/getPaginatedServiceTransactions",
      getTransaction: "transactions/getTransaction",
      deleteTransaction: "transactions/deleteTransaction",
      cancelTransaction: "transactions/cancelTransaction",
      saveTransaction: "transactions/saveTransaction",
      revertTransactionToSubmittedStatus:
        "transactions/revertTransactionToSubmittedStatus",
      getAllTransactionsForExporting:
        "transactions/getAllTransactionsForExporting",
    }),
    modalClose() {
      console.log('close');
    },
    toggleShowMoreFunction(value) {
      this.showMoreToggle = value; // Update variable
    },
    async clickShowDetailsModal(id) {
      this.editId = id;
      await this.$refs.transactionEditModal.show(this.editId);
    },
    async toggleLoading(action) {
      this.duringSubmit = action;
      if(this.duringSubmit)
        this.$loaderApp.addRequest();
      else
        this.$loaderApp.completeRequest();
    },
    isCompletedOrCancelled(row) {
      return row != "COMPLETED" && row != "CANCELLED" ? true : false;
    },
    async getPaginateTransactions() {
      var paginationInfo = {
        pageNumber: this.paginatedTransactions.currentPage
          ? this.paginatedTransactions.currentPage
          : 1,
        pageCount: this.pageCount,
        searchText: this.searchText ? this.searchText : "",
      };

      // Add showMore parameter only for PM1 users using service transactions
      if(this.isPM1Account) {
        paginationInfo.showMore = this.showMoreToggle;
      }

      this.duringSubmit = true;
      this.$loaderApp.addRequest();
      
      // PM1 role always use service-based endpoints, Sponsors use organization-based endpoints
      if(this.isPM1Account){
        var ret = await this.getPaginatedServiceTransactions(paginationInfo);
      }else{
        // Sponsor uses organization-based endpoints (no showMore parameter)
        var ret = await this.getPaginatedTransactions(paginationInfo);
      }
      
      this.duringSubmit = false;
      this.$loaderApp.completeRequest();
      return ret;
    },
    async search() {
      clearTimeout(this.searchTimeOut);

      var self = this;
      self.searchTimeOut = setTimeout(async () => {
        self.paginatedTransactions.currentPage = 1;
        await self.getPaginateTransactions();
      }, 1000);
    },
    async getExportData() {
      await this.getAllTransactionsForExporting(this.searchText);

      return Util.mapTheData(this.allTableData, this.map)
    },
    // async copyToClipboard() {
    //   Util.copyTableToClipboard(await this.getExportData());
    // },
    // async exportToExcel() {
    //    let reformattedExcel = await this.getExportData();
    //   let data = {
    //     exportList: reformattedExcel
    //   };
    //   try {
    //     let res = await axios({
    //       url: `api/ordertransactions/excel`,
    //       method: 'POST',
    //       data: data,
    //       responseType: "blob",
    //       config: { showToast: false },
    //     });
    //     Util.fileDownload(res.data, 'Transactions.xlsx');
    //   } catch (err) {
    //     var message = await err.response.data.text();
    //     this.$toast.error(message);
    //   }
    // },
    // async exportToCsv() {
    //   Util.exportToCsv("Transactions.csv", await this.getExportData());
    // },
    // async exportToPdf() {
    //   Util.exportToPdf("Transactions.pdf", await this.getExportData());
    // },
    handleDelete(row) {
      new swal({
        title: "Are you sure?",
        text: "Delete Transaction Order " + row + " ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#10b45a",
        cancelButtonColor: "red",
        confirmButtonText: "Yes, delete it!",
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.deleteTransaction(row);
        }
      });
    },
    openRevertModal(selectedOrderId) {
      this.selectedOrderToRevert = selectedOrderId;
      this.$refs.revertModal.show();
    },
    closeRevertModal() {
      this.$refs.revertModal.hide();
    },
    revertOrderToSubmittedStatus() {
      if (!Util.isNullOrEmpty(this.reasonForRevertingOrder.trim())) {
        let apiParameters = {
          OrderId: this.selectedOrderToRevert,
          Remarks: this.reasonForRevertingOrder,
        };
        this.revertTransactionToSubmittedStatus(apiParameters);
        this.search();
        this.closeRevertModal();
        return;
      }
      Util.swalConfirmation(
        "info",
        `Please provide a reason for reverting this order back to submitted status.`
      );
    },
    handleCancel(row) {
      new swal({
        title: "Are you sure?",
        text: "Cancel Transaction Order " + row + " ?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#10b45a",
        cancelButtonColor: "red",
        confirmButtonText: "Yes, cancel it!",
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.cancelTransaction(row).then(() => {
            this.getPaginateTransactions();
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.roles {
  width: 95%;
  margin: 2%;
}
</style>
